import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import EventForm from "./EventForm";

const EventCreationDialog = (props) => {
    return (
        <Box>
            {/* Modal for adding event */}
            <Dialog open={props.openModal} onClose={props?.handleCloseModal} disableEnforceFocus // ✅ this solves the CKEditor dropdown issue
            >
                <DialogTitle>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                        <Typography variant="h6">{`${props?.isEdit ? "Edit" : "Add New"} Event`}</Typography>
                        <IconButton onClick={props?.handleCloseModal}>
                            <CloseOutlined fontSize="small" />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <EventForm {...props} />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default EventCreationDialog;
